import { FieldHookConfig, useField } from 'formik';
import React from 'react';

import { TimePicker, TimePickerProps } from '../../../components/TimePicker';

interface TimePickerExtraProps {
  name: string;
}

type FormTimePickerProps = TimePickerProps &
  TimePickerExtraProps &
  FieldHookConfig<Date | null>;

export const FormTimePicker: React.FC<FormTimePickerProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { onChange, ...restProps } = props;

  const { setValue } = helpers;

  return (
    <TimePicker
      {...restProps}
      {...field}
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error ? meta.error : props.helperText}
      onChange={(value, context) => {
        setValue(value);
        if (onChange) onChange(value, context);
      }}
    />
  );
};
